export const ELEVENLABS_VOICE_CATALOG: ReadonlyArray<{ id: string; label: string }> = [
  { id: "FGY2WhTYpPnrIDTdsKH5", label: "Lora — warm default" },
  { id: "21m00Tcm4TlvDq8ikWAM", label: "Rachel — natural" },
  { id: "AZnzlk1XvdvUeBnXmlld", label: "Domi — strong" },
  { id: "EXAVITQu4vr4xnSDxMaL", label: "Bella — friendly" },
  { id: "ErXwobaYiN019PkySvjV", label: "Antoni — professional" },
  { id: "MF3mGyEYCl7XYWbV9V6O", label: "Elli — energetic" },
  { id: "TxGEqnHWrfWFTfGW9XjX", label: "Josh — deep" },
  { id: "VR6AewLTigWG4xSOukaG", label: "Arnold — crisp" },
  { id: "pNInz6obpgDQGcFmaJgB", label: "Adam — narrator" },
  { id: "yoZ06aMxZJJ28mfd3POQ", label: "Sam — casual" },
];

export const CATALOG_VOICE_ID_SET = new Set(ELEVENLABS_VOICE_CATALOG.map((v) => v.id));

export const CUSTOM_VOICE_SELECT = "__custom__";

export function elevenLabsVoiceLabel(voiceId: string): string | undefined {
  const id = voiceId.trim();
  if (!id) return undefined;
  return ELEVENLABS_VOICE_CATALOG.find((v) => v.id === id)?.label;
}

/** Agent-tab summary: preset label, "Custom voice", or legacy OpenAI name. */
export function assignedVoiceSummary(
  elevenVoiceId: string,
  openaiVoice: string,
): string | null {
  const elId = elevenVoiceId.trim();
  if (elId) {
    return elevenLabsVoiceLabel(elId) ?? "Custom voice";
  }
  const legacy = openaiVoice.trim();
  return legacy ? `${legacy} (OpenAI)` : null;
}
